<template>
  <v-flex xs12 class="text-xs-center" v-if="$store.state.spoils.loadingSpoils">
    <v-progress-circular indeterminate :color="$store.state.global.pages[$route.name].color"></v-progress-circular>
  </v-flex>
  <transition name="fadeToggle" mode="out-in" v-else>
    <v-flex xs12 v-if="listView">
      <v-card hover>
        <v-data-table
          :items="filteredSpoils"
          :headers="headers"
          :rows-per-page-items="itemsPerPageOptions"
        >
          <template slot="items" slot-scope="props">
            <table-row :headers="headers" :row="props.item" parent="Spoil" :key="props.item.id"></table-row>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>

    <transition-group name="data-list" tag="layout-no-padding" v-else>
      <v-flex
        xs12
        sm6
        md4
        xl3
        v-for="(spoil,i) in filteredSpoils"
        :key="spoil.id"
        class="data-list-item"
      >
        <spoil-card :spoil="spoil" :index="i"></spoil-card>
      </v-flex>
    </transition-group>
  </transition>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import SpoilService from '@/services/requests/spoilService'
import SpoilCard from '@/components/spoils/spoilCard'
import TableRow from '@/components/ui/masterFileTableRow'
import FilterByProps from '@/services/mixins/filterByProps'
export default {
  mixins: [FilterByProps],
  data() {
    return {
      headers: [
        {
          text: 'Name',
          align: 'left',
          value: 'name'
        },
        {
          text: 'Type',
          align: 'right',
          value: 'type'
        },
        {
          text: 'Actions',
          align: 'center',
          sortable: false
        }
      ],
      filters: ['name', 'type']
    }
  },
  computed: {
    sortBy: Store.getSet({ store: 'spoils', prop: 'sortBy' }),
    filterBy: Store.getSet({ store: 'spoils', prop: 'filterBy' }),
    listView: Store.getSet({ store: 'spoils', prop: 'listView' }),
    spoils: Store.getSet({ store: 'spoils', prop: 'spoils' }),
    selectedRecordType: Store.getSet({
      store: 'spoils',
      prop: 'selectedRecordType'
    }),
    sortedSpoils() {
      if (this.sortBy) {
        var path = this.sortBy
        return this.spoils.sort((a, b) => {
          //if(a[property] < b[property])
          if (this.getObjectPath(path, a) < this.getObjectPath(path, b)) {
            if (path == 'updatedAt') {
              return 1
            }
            return -1
          } else {
            if (path == 'updatedAt') {
              return -1
            }
            return 1
          }
        })
      } else {
        return this.spoils
      }
    },
    filteredSpoils() {
      // return this.filterListByMultipleProps(this.sortedSpoils, this.filters)

      return this.sortedSpoils.filter(spoil => {
        const nameMatch =
          spoil.name.toLowerCase().indexOf(this.filterBy.toLowerCase()) > -1
        const typeMatch =
          spoil.type.toLowerCase().indexOf(this.filterBy.toLowerCase()) > -1
        if (this.selectedRecordType === 'Request')
          return (nameMatch || typeMatch) && spoil.request
        else return (nameMatch || typeMatch) && !spoil.request
      })
    }
  },
  components: {
    SpoilCard,
    TableRow
  }
}
</script>

<style scoped>
</style>
